const userRewardStructure = {
    userId: "",               // Unique user ID
    userUUID: "",             // Global Unique Identifier for user
    userImage: "",            // Profile picture URL
    profileCount: 0,          // Total number of profiles user owns
    rewardCoins: 0,           // Coins earned from content creation, impressions, etc.
    socialCoins: 0,           // Coins earned from invites, shares, community interaction
    userImpressions: 0,       // Total impressions user content has received
  
    companyRevenue: 0,        // Total company revenue (for coin value calc)
    userCount: 0,             // Total user count on platform
    revenueGained: 0,         // Revenue attributed to this user’s content
    coinValueChange: 0,       // Dynamic coin value change based on platform metrics
  
    profiles: [               // Array of profile types (music, travel, etc.)
      {
        profileId: "",        // Profile identifier (e.g., "music", "travel")
        profileUUID: "",      // Unique profile ID
        postCount: 0,         // Total number of posts created under this profile
        admirerCount: 0,      // Number of admirers or followers
  
        posts: [              // Individual posts
          {
            postId: "",       // Unique post ID
            postUUID: "",     // Post's global UUID
            totalLikes: 0,    // Likes received
            totalShares: 0,   // Shares received
            totalComments: 0, // Comments received
            totalSuggest: 0,  // Suggests or recommendations
            impressions: {
              gainedImpressions: 0  // Impressions from audience
            }
          }
        ]
      }
    ],
  
    coinHistory: [            // Optional: Tracks changes in coins over time
      {
        type: "reward" | "social",
        amount: 0,
        reason: "",           // E.g., "Joined platform", "Posted content", etc.
        timestamp: ""         // ISO string or date
      }
    ],
  
    activityTimeline: [       // Optional: Timeline of user activities
      {
        action: "",           // E.g., "Created Post", "Invited Friend", etc.
        value: "",            // Coin earned or user engaged
        date: ""              // Date of the action
      }
    ],
  
    verified: false,          // Whether user is verified (e.g., bike expert, food critic)
    reputationScore: 0,       // Custom calculated metric based on honesty + consistency
    location: "",             // Optional: for geo insights
  };
  
  export default userRewardStructure;
  